import { V1Service } from '@hotjar/api-client-engage-insights';

export async function getThankYouDetails(shareId: string) {
  return V1Service.v1PublicUnmoderatedTestThankYouRetrieve(shareId);
}
